var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftTextBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80839 1.1612L6.33977 1.69258L3.20787 4.82331L3.03099 5.00012L3.20787 5.17693L6.33977 8.30765L5.80839 8.83904L1.97061 5.00012L5.80839 1.1612Z",
    fill: "black",
    fillOpacity: 0.898,
    stroke: "#222222",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftTextBlack);
export default __webpack_public_path__ + "static/media/ArrowLeftTextBlack.78c35131258f0d80b3c1b804264b6d21.svg";
export { ForwardRef as ReactComponent };